/* components/LightDarkToggle */

import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from "@/theme/ThemeComponent";

@Component
export class LightDarkToggle extends ThemeComponent {
    @Ref lightDarkToggle!: HTMLButtonElement;
    @Ref lightDarkLabel!: HTMLParagraphElement[];
    @Prop prefix!: string;

    private mode: boolean = false;
    private container!: HTMLDivElement;

    init() {
        this.container = this.lightDarkToggle.closest('.js-light-dark-text') as HTMLDivElement;

        this.container?.classList.add(`${this.prefix}--light`);

        this.$listen(this.lightDarkToggle, 'click', () => {
            this.toggle();
        });
    }

    private toggle() {
        if (!this.container) { return; }

        this.mode = !this.mode;
        this.container.classList.toggle(`${this.prefix}--light`);
        this.container.classList.toggle(`${this.prefix}--dark`);
        this.lightDarkToggle.classList.toggle('is-active');

        if (this.lightDarkLabel) {
            for (const label of this.lightDarkLabel) {
                label.classList.toggle('is-active');
            }
        }
    }
}
